import React from 'react';
import { X, Star, Quote, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import ModalShell from '../shared/ModalShell';

const QUOTE_MAX_LENGTH = 120;

const StoryDetailModal = ({ story, onClose }) => {
 return (
 <ModalShell
 isOpen={Boolean(story)}
 onClose={onClose}
 labelledBy="story-detail-title"
 panelClassName="max-w-lg"
 >
 {story && (
 <div className="bg-surface rounded-lg border border-border shadow-sm overflow-hidden">
 <div className="relative">
 <div className="h-48 sm:h-56 overflow-hidden">
 <img
 src={story.image || 'https://via.placeholder.com/800x600?text=Vendor+Story'}
 alt={story.vendor_name}
 className="w-full h-full object-cover"
 onError={(e) => {
 e.target.src = 'https://via.placeholder.com/800x600?text=Vendor+Story';
 }}
 />
 <div className="absolute top-3 left-3 bg-black/70 text-white px-2 py-1 rounded-full text-xs font-medium capitalize">
 {story.category}
 </div>
 <button
 type="button"
 onClick={onClose}
 className="absolute top-3 right-3 p-2 bg-surface/90 rounded-md hover:bg-surface transition-colors"
 aria-label="Close"
 >
 <X className="w-5 h-5 text-ink" />
 </button>
 </div>

 <div className="p-4 sm:p-6">
 <div className="flex items-center gap-2 mb-3">
 <Star className="w-5 h-5 text-yellow-500 fill-current" />
 <span
 id="story-detail-title"
 className="text-lg font-semibold text-ink"
 >
 {story.vendor_name}
 </span>
 </div>

 <div className="mb-4">
 <Quote className="w-6 h-6 text-gray-400 mb-2" />
 <p className="text-ink-secondary italic leading-relaxed">"{story.quote}"</p>
 </div>

 <div className="border-t border-border pt-4 mb-4">
 <p className="text-sm font-semibold text-ink">{story.author}</p>
 {story.role && <p className="text-sm text-ink-secondary">{story.role}</p>}
 </div>

 {story.stats && (story.stats.bookings || story.stats.rating || story.stats.revenue) && (
 <div className="grid grid-cols-3 gap-3 mb-4">
 {story.stats.bookings != null && (
 <div className="text-center p-2 bg-surface-muted rounded-xl border border-border">
 <div className="text-sm font-semibold text-ink">{story.stats.bookings}</div>
 <div className="text-xs text-ink-secondary">Bookings</div>
 </div>
 )}
 {story.stats.rating != null && (
 <div className="text-center p-2 bg-surface-muted rounded-xl border border-border">
 <div className="text-sm font-semibold text-ink flex items-center justify-center gap-1">
 <Star className="w-4 h-4 text-yellow-500 fill-current" />
 {story.stats.rating}
 </div>
 <div className="text-xs text-ink-secondary">Rating</div>
 </div>
 )}
 {story.stats.revenue && (
 <div className="text-center p-2 bg-surface-muted rounded-xl border border-border">
 <div className="text-sm font-semibold text-ink">{story.stats.revenue}</div>
 <div className="text-xs text-ink-secondary">Revenue</div>
 </div>
 )}
 </div>
 )}

 <Link
 to={story.vendor_id ? `/vendor/${story.vendor_id}` : '/browse-vendors'}
 className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-gray-900 text-white rounded-md font-semibold hover:bg-black transition-colors"
 >
 <ExternalLink className="w-4 h-4" />
 {story.vendor_id ? 'View Vendor Profile' : 'Browse Vendors'}
 </Link>
 </div>
 </div>
 </div>
 )}
 </ModalShell>
 );
};

export default StoryDetailModal;
export { QUOTE_MAX_LENGTH };
